<template>
  <header
    class="navbar-light fixed-top eader-sticky bg-white border-bottom"
    v-click-outside="clickHeaderOutside"
  >
    <!-- Logo Nav START -->
    <nav class="navbar navbar-expand-lg p-0">
      <div class="container">
        <!-- Logo START -->
        <a class="navbar-brand" href="/">
          <img
            class="light-mode-item navbar-brand-item"
            src="/img/logo.svg"
            alt="logo"
            style="height: 45px"
          />
        </a>
        <!-- Logo END -->

        <!-- <a class="text-dark mr-3" href="javascript:" style="font-size: 1.2rem">
          <i class="fas fa-bell"></i>
        </a> -->

        <div class="rounded position-relative d-none d-sm-block">
          <input
            class="form-control pl-5 bg-light"
            type="search"
            placeholder="Search..."
            aria-label="Search"
            v-model="textSearch"
            @keyup.enter="doSearch"
          />
          <button
            style="position: absolute; left: 0; bottom: 0.5rem"
            class="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y"
            type="button"
            @click="doSearch"
          >
            <i class="fas fa-search"> </i>
          </button>
        </div>

        <div class="position-relative d-block d-sm-none">
          <span v-if="noticeCount" class="notice-count">
            {{ noticeCount ? (noticeCount > 99 ? "99+" : noticeCount) : "" }}
          </span>
          <router-link
            :to="{ name: 'Notice' }"
            class="text-dark d-inline-block text-center"
            style="font-size: 1.2rem"
          >
            <i class="fas fa-bell"></i>
          </router-link>
        </div>

        <!-- Responsive navbar toggler -->
        <button
          class="navbar-toggler ms-auto icon-md btn btn-light"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="menuShow = !menuShow"
        >
          <i v-if="menuShow" class="fas fa-close"></i>
          <i v-else class="fas fa-bars"></i>
        </button>

        <div
          class="collapse navbar-collapse"
          id="navbarCollapse"
          :class="{ show: menuShow }"
        >
          <div
            class="nav mt-3 mt-lg-0 flex-nowrap align-items-center px-4 px-lg-0 d-block d-sm-none"
          >
            <div class="nav-item w-100">
              <div class="rounded position-relative">
                <input
                  class="form-control pl-5 bg-light"
                  type="search"
                  placeholder="Search..."
                  aria-label="Search"
                  v-model="textSearch"
                  @keyup.enter="doSearch"
                />
                <button
                  style="position: absolute; left: 0; bottom: 0.5rem"
                  class="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y"
                  type="button"
                  @click="doSearch"
                >
                  <i class="fas fa-search"> </i>
                </button>
              </div>
            </div>
          </div>

          <ul class="navbar-nav navbar-nav-scroll ml-auto text-center">
            <li class="nav-item mx-2 d-inline-block">
              <router-link
                :to="{ name: 'Idea' }"
                class="nav-link text-dark d-inline-block text-center idea"
                :class="{ active: routeName == 'IdeaDetail' }"
              >
                <i class="fas fa-lightbulb" style="font-size: 1.2rem"></i>
                <br />
                <strong>IDEAS</strong>
              </router-link>
            </li>
            <li class="nav-item mx-2 d-inline-block">
              <router-link
                :to="{ name: 'Challenge' }"
                class="nav-link text-dark d-inline-block text-center challenge"
                :class="{ active: routeName == 'ChallengeDetail' }"
              >
                <i class="fas fa-person-hiking" style="font-size: 1.2rem"></i>
                <br />
                <strong>CHALLENGES</strong>
              </router-link>
            </li>
            <li
              class="nav-item mx-2 position-relative d-none d-sm-inline-block"
            >
              <span v-if="noticeCount" class="notice-count">
                {{
                  noticeCount ? (noticeCount > 99 ? "99+" : noticeCount) : ""
                }}
              </span>
              <router-link
                :to="{ name: 'Notice' }"
                class="nav-link text-dark d-inline-block text-center"
              >
                <i class="fas fa-bell" style="font-size: 1.2rem"></i>
                <br />
                <strong>NOTIFICATIONS</strong>
              </router-link>
            </li>
            <li class="nav-item mx-4">
              <CHeaderNav>
                <TheHeaderDropdownAccnt />
              </CHeaderNav>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Logo Nav END -->
  </header>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
      menuShow: false,
      textSearch: null,
    };
  },
  created: function () {
    this.$messageHub.$on("UpdatedNotice", this.updateNotice);
  },
  beforeDestroy: function () {
    //clean SignalR event
    this.$messageHub.$off("UpdatedNotice", this.updateNotice);
  },
  mounted() {
    if (this.queryObject && this.queryObject.keywords) {
      this.textSearch = this.queryObject.keywords;
    }
    this.$user.dispatch("getNoticeCount");
  },
  computed: {
    noticeCount: function () {
      return this.$user ? this.$user.getters.noticeCount : 0;
    },
    routeName() {
      return this.$route.name;
    },
    queryObject() {
      let val = this.$route.query;
      return {
        page: val.page ?? 1,
        pageSize: val.pageSize ?? 10,
        sortBy: val.sortBy ?? "UpdatedAt desc",
        keywords: val.keywords,
        isMine: val.isMine,
        status: Array.isArray(val.status)
          ? val.status
          : val.status
          ? [val.status]
          : [1, 2, 4],
        area: Array.isArray(val.area) ? val.area : val.area ? [val.area] : [],
        likeFrom: val.likeFrom,
        likeTo: val.likeTo,
      };
    },
    sipUser() {
      let sipUser = localStorage.getItem("sipUser");
      if (sipUser) {
        return JSON.parse(sipUser);
      } else {
        return null;
      }
    },
  },
  methods: {
    doSearch() {
      let textSearch = this.textSearch;
      this.pushRouter(textSearch);
      this.menuShow = false;
    },
    pushRouter(textSearch) {
      let query = this.queryObject;
      let routeName = this.routeName;
      query["keywords"] = textSearch;
      query["page"] = "1";
      query["isMine"] = false;
      query["status"] = [];
      query["area"] = [];
      query["likeFrom"] = 0;
      query["likeTo"] = 0;
      //console.log(query);

      this.$router
        .push({
          name: ["Challenge", "ChallengeDetail"].includes(routeName)
            ? "Challenge"
            : "Idea",
          query: query,
        })
        .catch(() => {});
    },

    clickHeaderOutside() {
      this.menuShow = false;
    },

    updateNotice({ userId }) {
      if (this.sipUser && this.sipUser.UserId == userId) {
        this.$user.dispatch("getNoticeCount");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  &.active {
    color: #321fdb !important;
  }
  &.idea {
    &.active {
      color: #007bff !important;
    }
  }
  &.challenge {
    &.active {
      color: #f9b115 !important;
    }
  }
}
.notice-count {
  position: absolute;
  top: 0;
  left: 50%;
  display: inline-block;
  border-radius: 50%;
  width: 1.2rem;
  height: 1.2rem;
  background-color: red;
  color: #fff;
  line-height: 1rem;
  font-size: 0.8rem;
  text-align: center;
}
</style>
